import script from "./GroupAssignDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupAssignDialog.vue?vue&type=script&setup=true&lang=js"

import "./GroupAssignDialog.vue?vue&type=style&index=0&id=b117df8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b117df8a"]])

export default __exports__